module.exports = __webpack_public_path__ + "static/img/coreTechnology_3.45af648.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/coreTechnology_3.jpg
// module id = w0r/
// module chunks = 0